import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getWhyChooseSliceContent = createAsyncThunk('/whyChooses/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getWhyChoose`, {});
	return response;
})

export const whyChooseSlice = createSlice({
    name: 'whyChooses',
    initialState: {
        isLoading: false,
        whyChooses : []
    },
    reducers: {
    },
    extraReducers: {
		[getWhyChooseSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getWhyChooseSliceContent.fulfilled]: (state, action) => {
			state.whyChooses = action.payload.data
			state.isLoading = false
		},
		[getWhyChooseSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default whyChooseSlice.reducer